import React from 'react';
import './App.css';
import './i18n';
import { AuthProvider } from './auth/AuthProvider';
import { useAuth } from './auth/useAuth';
import { ProtectedRoute } from './auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import AdminUsersPage from './pages/AdminUsersPage';
import VerificationAnalyticsPage from './pages/VerificationAnalyticsPage';
import VerificationSuccessPage from './pages/VerificationSuccessPage';
import VerificationFailurePage from './pages/VerificationFailurePage';
import UserForm from './components/UserForm';

// Компонент с роутингом внутри AuthProvider
const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading, isAdmin, user, logout } = useAuth();
  const path = window.location.pathname;

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Загрузка...</div>
      </div>
    );
  }

  // Страница авторизации доступна всем
  if (path === '/login') {
    return <LoginPage />;
  }

  // Страницы редиректа от AbleID (доступны без авторизации, так как это редиректы)
  if (path === '/verification/success') {
    return <VerificationSuccessPage />;
  }

  if (path === '/verification/failure') {
    return <VerificationFailurePage />;
  }

  // Если не авторизован, редирект на логин
  if (!isAuthenticated) {
    window.location.href = '/login';
    return null;
  }

  // Админские страницы
  if (path === '/admin/users') {
    return <AdminUsersPage />;
  }

  if (path === '/admin/analytics') {
    return <ProtectedRoute><VerificationAnalyticsPage /></ProtectedRoute>;
  }

  // Главная страница с формой верификации
  return (
    <ProtectedRoute>
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginBottom: '20px',
          padding: '0 20px'
        }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <span style={{ color: '#666', fontSize: '14px' }}>
              {user?.fullName} ({user?.role === 'admin' ? 'Админ' : 'Тестер'})
            </span>
            {isAdmin && (
              <>
                <a 
                  href="/admin/users" 
                  className="secondary-button"
                  style={{ textDecoration: 'none', padding: '8px 16px', fontSize: '14px' }}
                >
                  Управление пользователями
                </a>
                <a 
                  href="/admin/analytics" 
                  className="secondary-button"
                  style={{ textDecoration: 'none', padding: '8px 16px', fontSize: '14px' }}
                >
                  Аналитика
                </a>
              </>
            )}
            <button 
              className="secondary-button"
              onClick={logout}
              style={{ padding: '8px 16px', fontSize: '14px' }}
            >
              Выйти
            </button>
          </div>
        </div>
        <div style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
          <h1 className="page-title" style={{ marginBottom: '20px', textAlign: 'center' }}>
            Верификация личности
          </h1>
          <p style={{ marginBottom: '20px', fontSize: '16px', color: '#666' }}>
            Вам необходимо выбрать язык, ввести ПИНФЛ (14 цифр) и проверить дату рождения. 
            Далее нажмите кнопку "Начать проверку".
          </p>
          <UserForm prefillDobFromPinfl />
        </div>
      </div>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
